<template>
  <div class="form_box">
    <div class="form_box__header">
      <AppPageHeader></AppPageHeader>
    </div>
    <el-card class="box-card">

      <el-table :data="datas" style="width: 100%" v-loading="loading">
        <!-- <template slot-scope="props">
          <el-row>
            <el-col :span="4">
                UID:
            </el-col>
            <el-col :span="8">
                {{props.row.uid}}
            </el-col>
          </el-row>
        </template> -->

        <el-table-column
          type="index"
          width="100">
        </el-table-column>
        <el-table-column
          prop="cdate"
          label="数据时间"
          width="100">
        </el-table-column>
        <el-table-column label="姓名" prop="name">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p>姓名: {{ scope.row.name }}</p>
              <p>ID: {{ scope.row.uid }}</p>
              <div slot="reference" class="name-wrapper">
                {{scope.row.name}}
              </div>
            </el-popover>
          </template>

        </el-table-column>
        <el-table-column label="已获得学分" width="100">
          <template slot-scope="scope">
            <div>
              <template v-if="!scope.row.checked || scope.row.checked == 0">
                <span class="font_danger_color">未完成</span>
              </template>
              <template v-if="scope.row.checked == 1">
                <span class="font_success_color">已完成</span>                
              </template>            
            </div>
          </template>
        </el-table-column>
        <el-table-column label="排课信息" prop="scheduleBrief" width="600">
        </el-table-column>
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <div>
              <template v-if="!scope.row.status">
                <span>未完成</span>
              </template>
              <template v-else-if="scope.row.status == 0">
                <span>已报名</span>                
              </template>       
              <template v-else-if="scope.row.status == 1">
                <span>已签到</span>                
              </template>    
              <template v-else-if="scope.row.status == 2">
                <span>已签退</span>                
              </template>         
              <template v-else-if="scope.row.status == 3">
                <span>已旷课</span>                
              </template>   
              <template v-else-if="scope.row.status == 4">
                <span>已请假</span>                
              </template>   
              <template v-else-if="scope.row.status == 5">
                <span>已补签</span>                
              </template>   
              <template v-else-if="scope.row.status == 6">
                <span>申请补签</span>                
              </template> 
              <template v-else-if="scope.row.status == 7">
                <span>申请请假</span>                
              </template> 
            </div>
          </template>
        </el-table-column>
        <el-table-column align="left">
          <template slot="header">补签 / 补请假</template>
          <template slot-scope="scope">
            <template v-if="scope.row.checked != 1">
                <el-button size="mini" type="primary" @click="confirm(scope.row.id)">补签</el-button>
            </template>                 
            <template v-if="scope.row.checked == 1">
                <el-button size="mini" type="danger" @click="cancelFillCheck(scope.row.id)">取消补签</el-button>
            </template>   
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 补请假内容 -->
    <el-dialog title="请假理由" :visible.sync="dialogLeaveFormVisible">
      <el-form>
        <el-form-item label="请假理由" label-width="150px">
          <el-input
            type="textarea"
            :rows="3"
            placeholder="请输入请假理由"
            v-model="leaveform.reason"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="onClickLeaveFormCancelBtn">取 消</el-button>
        <el-button type="primary" @click="onClickLeaveFormSubmitBtn">确 定</el-button>
      </div>
    </el-dialog>


  </div>
</template>


<script>

import { FillCheckUnSignUp } from "@/views/module/fillcheck/comp"
import { scheduleApplyApi } from "@/api/module/userscheduling"
import { fillCheckDirectApi,fillcheckCancelApi,fillCheckDirectByIdApi } from "@/api/module/fillcheck/fillcheck";
import { repairUserLeave } from "@/api/module/userleave/userleave";

export default {
  name: "fill-check-all",
  components: {
    FillCheckUnSignUp
  },
  data() {
    return {
      datas: [],
      loading :false,
      dialogLeaveFormVisible: false,
      leaveform: {
        sid: "",
        uid: "",
        reason: ""
      },
    }
  },

  methods:{
    init(){

      scheduleApplyApi()
        .then((r) =>{
          this.datas = r;
        })
    },

    confirm(id){
      this.loading = true;

      fillCheckDirectByIdApi(id)
        .then(()=>{
          this.$message.success("补签成功！");
          this.loading = false;
        })
        .finally(()=>{
          this.loading = false;
          this.init();
        })
    },

    cancelFillCheck(id){

      fillcheckCancelApi(id)
        .then(()=>{
          this.$message.success("取消补签成功")
          this.init();
        })

    }
  },
  mounted(){
    this.init();
  }
}




</script>



<style scoped lang="scss">
.box-card {
  margin-bottom: 20px;
  .top_info {
    div {
      font-size: 14px;
      margin-right: 30px;
      margin-bottom: 18px;
    }
  }
  .classTitle {
    font-size: 16px;
    color: #303133;
    font-weight: 600;
    padding-top: 20px;
    border-top: 1px dotted #ddd;
  }
  .oneItem{
    border-top: 1px dotted #ddd;
    padding-top: 15px;
    &>div{
      margin-bottom: 18px;
    }
  }
  .title {
    color: #303133;
    font-weight: 500;
    display: inline-block;
    font-size: 14px;
    width: 105px;
  }
  .cont {
    color: #3e3e3e;
    font-size: 14px;
  }
}
.clearfix {
  font-size: 16px;
  color: #303133;
  font-weight: 600;
}
</style>